import React from "react";
import styled from "@emotion/styled";

const MenuWrapper = styled.div`
    border-radius: 4px;
    overflow: hidden;
`;

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 12px 16px 8px;
`;

const ActionLink = styled.span`
    color: var(--color-brand-pink-primary);
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    user-select: none;
`;

const FooterDivider = styled.div`
    margin: 0 16px;
    border-top: 1px solid #e8e8e8;
`;

const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 10px 16px;
    gap: 16px;
`;

const CancelLink = styled.span`
    cursor: pointer;
    font-size: 14px;
    color: #555;
    user-select: none;
`;

const SaveButton = styled.button`
    padding: 6px 20px;
    cursor: pointer;
    background: var(--color-brand-pink-primary);
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 400;
`;

export const CustomMenuList = ({children, options, selectProps}) => {
    const {onSelectAll, onClearAll, onSave, onCancel} = selectProps;
    return (
        <MenuWrapper>
            <Header>
                <ActionLink onClick={onSelectAll}>Select All</ActionLink>
                <ActionLink onClick={onClearAll}>Clear</ActionLink>
            </Header>

            <div>{children}</div>

            <FooterDivider/>
            <Footer>
                <CancelLink onClick={onCancel}>Cancel</CancelLink>
                <SaveButton onClick={onSave}>Save</SaveButton>
            </Footer>
        </MenuWrapper>
    );
};